import request from '@/request'

export function getDepartamento() {
  return request({
    url: '/web/tdep01/39913492-498b-44ea-831c-28ba909f5fa4',
    method: 'get'
  })
}

export function getDepartamentoFiltro() {
  return request({
    url: '/web/tdep01f/39913492-498b-44ea-831c-28ba909f5fa4',
    method: 'get'
  })
}

export function getTipoLinea() {
  return request({
    url: '/web/l01/39913492-498b-44ea-831c-28ba909f5fa4',
    method: 'get'
  })
}

export function getTipoCiiu() {
  return request({
    url: '/web/tciiu01/39913492-498b-44ea-831c-28ba909f5fa4',
    method: 'get'
  })
}

export function getTipoNivelEscolar() {
  return request({
    url: '/web/tnve01/39913492-498b-44ea-831c-28ba909f5fa4',
    method: 'get'
  })    
}

export function getTipoGarantia() {
  return request({
    url: '/web/tgar01/39913492-498b-44ea-831c-28ba909f5fa4',
    method: 'get'
  })    
}

export function getSolicitudToken(token) {
    return request({
      url: `/web/tpgso01/${token}/39913492-498b-44ea-831c-28ba909f5fa4`,
      method: 'get'
    })
}

export function postSolicitud(data) {
  return request({
    url: '/web/tpsol01/39913492-498b-44ea-831c-28ba909f5fa4',
    method: 'post',
    data
  })
}

export function getMunicipio(dept_id) {
  return request({
    url: `/web/tmun01/${dept_id}/39913492-498b-44ea-831c-28ba909f5fa4`,
    method: 'get'
  })
}

export function getAsesores() {
  return request({
    url: '/web/tpases/39913492-498b-44ea-831c-28ba909f5fa4',
    method: 'get'
  })
}

export function getTipoParentesco() {
  return request({
    url: '/web/tpar01/39913492-498b-44ea-831c-28ba909f5fa4',
    method: 'get'
  })
}

export function getTipoReferencia() {
  return request({
    url: '/web/tref01/39913492-498b-44ea-831c-28ba909f5fa4',
    method: 'get'
  })
}